import { render } from "./EditUserGroup.vue?vue&type=template&id=6a0b48ce"
import script from "./EditUserGroup.vue?vue&type=script&lang=js"
export * from "./EditUserGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__